import React from "react";

const packages = [
  {
    id: 1,
    title: "ฉากพิธีรดน้ำสังข์",
    image: "/img/package/wedding-screen.jpg",
    items: [
      { name: "ฉากพิธีรดน้ำสังข์ 3.6*2.4", quantity: 1 },
      { name: "พานใส่สายสิน", quantity: 1 },
      { name: "ขันใส่แป้งเจิม", quantity: 1 },
      { name: "ขันน้ำมนต์", quantity: 1 },
      { name: "หอยสังข์+ที่วางหอยสังข์", quantity: 1 },
      { name: "ปูพื้น(ขาว)", quantity: 1 },
      { name: "บล็อคดอกไม้", quantity: 2 },
      { name: "ขาตั้งรูป", quantity: 1 },
      { name: "สายสินรับไหว้(ผูกข้อมือ)", quantity: 1 },
      { name: "สายมงคล", quantity: 1 },
      { name: "แป้งเจิม", quantity: 1 },
      { name: "ป้ายชื่อ", quantity: 1 },
      { name: "พานดอกไม้สด", quantity: 2 },
      { name: "มาลัยบ่าวสาวสด", quantity: 2 },
      { name: "ผ้าข้าวปิดด้านข้าง", quantity: 2 },
      { name: "ฉากพิธีรดน้ำสังข์", quantity: "ราคา 6,000 บาท" },
    ],
  },
  {
    id: 2,
    title: "ฉากหลังพระ",
    image: "/img/package/wedding-screen3.jpg",
    items: [
      { name: "***ฉากหลังพระ 2.4*10", quantity: 1 },
      { name: "ชุดโต๊ะหมู่บูชา", quantity: 1 },
      { name: "หมอนกราบบ่าวสาว", quantity: 2 },
      { name: "พรหมให้แขกในงาน", quantity: 4 },
      { name: "พรมสำหรับบ่าวสาว", quantity: 1 },
      { name: "อาสนะพระ+พนักพิง", quantity: 9 },
      { name: "กระโถน", quantity: 9 },
      { name: "แจกันดอกไม้", quantity: 2 },
      { name: "เชิงเทียน+เทียน", quantity: 2 },
      { name: "กระถางธูป", quantity: 1 },
      { name: "ที่กรวดน้ำ", quantity: 1 },
      { name: "ที่จุดเทียน", quantity: 1 },
      { name: "ผ้ารองพระพุธ", quantity: 1 },
      { name: "สายสินม้วน", quantity: 1 },
      { name: "ดอกไม้กำหน้าพระพุธ", quantity: 2 },
      { name: "ดอกไม้ถวายพระ", quantity: 9 },
      { name: "ฉากพระ", quantity: "ราคา 6,000 บาท" },
    ],
  },
  {
    id: 3,
    title: "***โปรโมชั่น***",
    image: "/img/package/wedding-screen2.jpg",
    items: [
      { name: "ครบเซตลดให้เหลือ", quantity: "ราคา 11,000 บาท" },
      { name: "ฉากกินเลี้ยง 3.6 เมตร", quantity: "ราคา 5,500 บาท" },
      { name: "แถมซุ้มทางเข้างาน", quantity: "ฟรี" },
      { name: "รวม", quantity: "ราคา 16,500 บาท" },
    ],
  },
];

export const Services = () => {
  return (
    <div id="package" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Package</h2>
          <p>รายละเอียดแพ็กเกจ</p>
        </div>
        <div className="row">
          {packages.map(({ id, title, image, items }) => (
            <div key={id} className="col-md-4">
              <img
                width={300}
                alt="logo"
                src={image}
                style={{ borderRadius: 6 }}
              />
              <div className="service-desc">
                <h3>{title}</h3>
                {items.map(({ name, quantity }, index) => (
                  <div className="item-list" key={index}>
                    <span className="item-name">{name}</span>
                    <span className="item-quantity">{quantity}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
